const sendLogToBackend = (err: { message: string, stack?: string }, store: any) =>
{
    store.dispatch("log/sendLogToBackend", err)
    .then(
        (success: any) => {
        },
        (error: any) => console.log(error)
    )
    .catch((error: any) => console.log(error));
}

export
{
    sendLogToBackend
}